import React from 'react';
import Button from '../button';
import './index.css';

export default function AiButton({className, onClick, children, disabled}) {

	return (
		<Button
			disabled={ disabled }
			onClick={ onClick }
			className={`btn-ai${className ? ' ' + className : ''}`}
		>
			<svg className="mr-2" width="20" height="20" viewBox="0 0 24 24" fill="none"
			     xmlns="http://www.w3.org/2000/svg">
				<path
					fill="currentColor"
					d="M1.77 24.01 0 22.24l9.51-9.54-5.72-1.42 6.26-3.89L9.51 0l5.66 4.77 6.82-2.78-2.75 6.86 4.77 5.62-7.39-.51-3.92 6.26-1.42-5.72zm.76-16.43L0 5.05l2.53-2.53 2.53 2.53zm11.22 6.22 1.52-2.5 2.94.22-1.9-2.24 1.11-2.72-2.72 1.11-2.24-1.86.22 2.91-2.5 1.55 2.84.7.73 2.84zm5.21 10.21-2.53-2.53 2.53-2.53 2.53 2.53zM14.19 9.79" />
			</svg>
			{children}
		</Button>
	);
}
